import {Button, Spinner} from '@chakra-ui/react';
import {TrashIcon} from '@/components/svg/TrashIcon';

export const DeleteButton: React.FC<{
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}> = ({onClick, isLoading = false, isDisabled = false}) => {
  return (
    <Button
      variant='ghost'
      aria-label='delete'
      h={{base: '20px', md: '35px'}}
      w='30px'
      px='0'
      minW='30px'
      onClick={onClick}
      isDisabled={isDisabled || isLoading}
    >
      {isLoading ? (
        <Spinner boxSize='18' />
      ) : (
        <TrashIcon
          width='21'
          height='21'
        />
      )}
    </Button>
  );
};
